module.exports = __webpack_public_path__ + "de3787a160459294f20fa1c2c186d80d.MP3";